export const homepageFeatureCards = [
  {
    title: 'Create invoices online in minutes',
    description:
      'Add your business details, client information, line items, taxes, and payment terms from one browser-based invoice generator — no account needed.',
  },
  {
    title: 'Customize professional invoice templates',
    description:
      'Choose from multiple invoice templates and adjust styling, colours, and layout so every invoice is consistent with your brand.',
  },
  {
    title: 'Download polished PDF invoices',
    description:
      'Generate clean, professional PDF invoices from your current invoice data. Ready to send, attach, or archive.',
  },
  {
    title: 'Multi-currency and tax support',
    description:
      'Invoice clients in USD, GBP, EUR, and more. Add per-item tax rates, VAT, and payment terms to match your billing requirements.',
  },
  {
    title: 'Live invoice preview',
    description:
      'See exactly how your invoice will look as you build it. Edit details, switch templates, and watch the preview update in real time.',
  },
  {
    title: 'Built for freelancers and small businesses',
    description:
      'Use Invo as a lightweight invoicing tool for freelancers, consultants, agencies, contractors, and growing small business teams.',
  },
];

export const homepageUseCases = [
  'Freelancers who need a simple invoice maker without complicated setup or sign-up',
  'Consultants and agencies creating branded invoices with tax and payment details',
  'Small businesses that want faster invoice drafting and PDF export from one tool',
  'Contractors invoicing clients internationally with multi-currency support',
  'Creative professionals who want clean, modern invoice templates',
];

export const homepageFaqs = [
  {
    question: 'How do I create an invoice online with Invo?',
    answer:
      'Open the invoice builder, add your business and client details, enter your line items, set payment terms, and download the finished invoice as a PDF.',
  },
  {
    question: 'Is Invo free to use?',
    answer:
      'Yes. Invo is completely free. There is no account required, no trial period, and no hidden fees. You can create and download PDF invoices at no cost.',
  },
  {
    question: 'Is Invo a good invoice generator for freelancers and small businesses?',
    answer:
      'Yes. Invo is designed for freelancers, agencies, consultants, and small businesses that need a fast browser-based invoicing workflow without unnecessary complexity.',
  },
  {
    question: 'Can I customize invoice templates before downloading a PDF?',
    answer:
      'Yes. You can choose from multiple professional invoice templates, adjust colours and styling, and preview the result live before generating your PDF invoice.',
  },
  {
    question: 'Can I use Invo as a PDF invoice maker?',
    answer:
      'Yes. Invo generates downloadable PDF invoices, making it useful for businesses that need professional invoice documents ready to send to clients.',
  },
  {
    question: 'Do I need to create an account to use Invo?',
    answer:
      'No. Invo works entirely in your browser with no sign-up, no login, and no personal data collection required.',
  },
  {
    question: 'Does Invo support multiple currencies?',
    answer:
      'Yes. Invo supports multiple currencies including USD, GBP, EUR, and more, so you can invoice clients internationally.',
  },
];

export const homepageHowItWorks = [
  {
    step: 1,
    title: 'Enter your business details',
    description: 'Add your company name, address, email, and logo.',
  },
  {
    step: 2,
    title: 'Add client and line items',
    description: 'Fill in your client info, add services or products with quantities and rates.',
  },
  {
    step: 3,
    title: 'Customize and preview',
    description: 'Pick a template, adjust styling, and see the live preview update instantly.',
  },
  {
    step: 4,
    title: 'Download your PDF invoice',
    description: 'Hit download and get a clean, professional PDF ready to send.',
  },
];
